<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  postSaleCaseId: { type: [Number, String], required: true },
  statuses: { type: Array, default: () => [] },
});

const emit = defineEmits(['openCase']);
const { t } = useI18n();
const durations = computed(() =>
  props.statuses.map(status => Number(status.diferenca_dias) || 0)
);
const minimumDays = computed(() => Math.min(...durations.value));
const maximumDays = computed(() => Math.max(...durations.value));

const segmentSize = days => Math.max(Number(days) || 0, 0);
const segmentColor = days => {
  const duration = segmentSize(days);
  const range = maximumDays.value - minimumDays.value;
  const percent = range ? (duration - minimumDays.value) / range : 0;
  const hue = 40 - percent * 40;
  const lightness = 80 - percent * 30;
  return `hsl(${hue}, 70%, ${lightness}%)`;
};
const statusLabel = status =>
  t('POST_SALE.MANAGEMENT.DEEDS_STATUS_DAYS', {
    status: status.nome_status,
    days: status.diferenca_dias,
  });
</script>

<template>
  <div
    class="flex w-full items-stretch overflow-hidden rounded-lais-sm"
    role="list"
  >
    <button
      v-for="(status, index) in statuses"
      :key="`${status.nome_status}-${index}`"
      type="button"
      role="listitem"
      data-status-segment
      class="group flex min-w-0 basis-0 flex-col text-center focus-visible:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-lais-primary"
      :style="{ flexGrow: segmentSize(status.diferenca_dias) }"
      :title="statusLabel(status)"
      :aria-label="statusLabel(status)"
      @click="emit('openCase', postSaleCaseId)"
    >
      <span class="truncate px-2 pb-1 text-xs text-lais-text-body">
        {{ status.nome_status }}
      </span>
      <span
        data-status-color
        class="h-7 w-full transition group-hover:scale-[1.02] group-hover:shadow-md"
        :style="{ backgroundColor: segmentColor(status.diferenca_dias) }"
        aria-hidden="true"
      />
      <strong class="px-2 pt-1 text-xs text-lais-text">
        {{ status.diferenca_dias }}
      </strong>
    </button>
  </div>
</template>
